const projectsData = [
  {
    id: '01',
    name: 'MyKash',
    image: '/Projects/mykash.webp',
    category: 'Mobile Banking',
    stack: 'Full-stack',
    shortDescription:
      'This is a Mobile Financial Service (MFS) application built with three roles—user, agent, and admin—designed to facilitate seamless money transfers, cash-in and cash-out transactions, and efficient account management.',
    technologies: [
      'React Vite',
      'Tailwind',
      'Node-js',
      'Express-js',
      'MongoDB',
      'Vercel',
    ],
    features: [
      'Users can send money to other users and perform cash-in and cash-out transactions with the assistance of agents.',
      'Agents help users with cash transactions, ensuring a smooth experience.',
      'Admins can block users, approve agent accounts, and manage recharge requests.',
    ],
    status: 'Developing',
    show: 'on',
    liveURL: 'https://mykash.vercel.app/',
    source: {
      client: 'https://github.com/tigermursa/MyKash-Client-Site',
      server: 'https://github.com/tigermursa/MyKash-Server-site',
    },
  },
  {
    id: '02',
    name: 'Task Buddy',
    image: '/Projects/task-buddyy.webp',
    category: 'Goals',
    stack: 'Full-stack',
    shortDescription:
      'An intuitive MERN stack project designed to help you manage your daily tasks efficiently and stay organized effortlessly.',
    technologies: [
      'React-vite',
      'Tailwind',
      'Node-js',
      'TypeScript',
      'Express-js',
      'MongoDB',
      'Vercel',
    ],
    features: [
      'Keep track of your daily to-dos seamlessly.',
      'Integrated calendar for scheduling tasks effectively.',
      'Built-in notepad for quick and easy note-taking.',
      'PAW integration to use the app conveniently on your PC.',
    ],
    status: 'Ready',
    show: 'on',
    liveURL: 'https://task-buddy-client.vercel.app/login',
    source: {
      client: 'https://github.com/tigermursa/TaskBuddy-Client',
      server: 'https://github.com/tigermursa/Task-Buddy-Server',
    },
  },
  {
    id: '03',
    name: 'Amelina Pizza ',
    image: '/Projects/AmelinaPizza.webp',
    category: 'E-commerce',
    stack: 'Frontend',
    shortDescription:
      'A visually appealing pizza ordering platform built to showcase creative design and provide a smooth user experience. Plans for future enhancements are underway.',
    technologies: ['Next-js', 'Tailwind', 'Vercel'],
    features: [
      'Customize your pizza order to match your exact preferences.',
      'A sleek and intuitive user interface for seamless navigation.',
      'Effective cart management for a hassle-free checkout process.',
    ],
    status: 'Have plans to update',
    show: 'on',
    liveURL: 'https://amelinapizza.vercel.app/',
    source: {
      client: 'https://github.com/tigermursa/pizza-Amelia',
    },
  },
  {
    id: '04',
    name: 'MyTube',
    image: '/Projects/mytube.webp',
    category: 'Tool',
    stack: 'Full-stack',
    shortDescription:
      'A distraction-free YouTube clone designed to help you store and watch your favorite videos without interruptions, ensuring you never lose valuable content.',
    technologies: [
      'Next-js',
      'Tailwind',
      'Node-js',
      'Express-js',
      'MongoDB',
      'Vercel',
    ],
    features: [
      'Save and organize your most valuable videos effortlessly.',
      'A personalized YouTube experience tailored just for you.',
      'Ensure your favorite videos are always accessible.',
      'Efficient CRUD operations for seamless video management.',
    ],
    status: 'Developing',
    show: 'on',
    liveURL: 'https://mytube-mursalin.vercel.app',
    source: {
      client: 'https://github.com/tigermursa/Mytube',
      server: 'https://github.com/tigermursa/MyTube-server',
    },
  },
];

export default projectsData;
